import React, { useEffect, useState } from "react";

/**
 * Redux
 */
import { UseAppDispatch } from "redux/store";
import { useSelector } from "react-redux";
import { setCheckoutSlice } from "redux/checkoutSteps";
import { setFullContactInformationSlice } from "redux/contactInformation";
import {
  setFullTravelerInformationSlice,
  travelerInformationSelector,
  ITraveler,
  ITravelerInformation,
} from "redux/travelerInformation";

/**
 * Mui Components
 */
import { Button } from "@mui/material";

/**
 * Shared Utils
 */

/**
 * Dummy Data
 */
import {
  checkoutStepsDummy,
  contactInformationDummy,
  travelerAdultDummy,
  travelerChildDummy,
  travelerInfantDummy,
  travelerStudentDummy,
  travelerYouthDummy,
} from "assets/dummy/autofillData";

/**
 * Third party libraries
 */
import { useSearchParams } from "react-router-dom";
import { deepCloneObject } from "@thekilroygroup/shared-ui";

export const LazyMussa = () => {
  const [searchParams] = useSearchParams();
  const [showAutoFill, setShowAutofill] = useState(false);
  const dispatch = UseAppDispatch();
  const travelerSlice = useSelector(travelerInformationSelector);

  useEffect(() => {
    if (searchParams.get("lazyMussa")) {
      setShowAutofill(true);
    }
  });

  const autofillForms = () => {
    dispatch(setCheckoutSlice(checkoutStepsDummy));
    dispatch(setFullContactInformationSlice(contactInformationDummy));
    let nextTravelerSlice: ITravelerInformation =
      deepCloneObject(travelerSlice);

    travelerSlice.travelers.forEach((traveler: ITraveler, i: number) => {
      if (traveler.passengerType === "ADT") {
        nextTravelerSlice.travelers[i] = travelerAdultDummy;
      } else if (
        traveler.passengerType === "CNN" ||
        traveler.passengerType === "CHD"
      ) {
        nextTravelerSlice.travelers[i] = travelerChildDummy;
      } else if (traveler.passengerType === "INF") {
        nextTravelerSlice.travelers[i] = travelerInfantDummy;
      } else if (traveler.passengerType === "YTH") {
        nextTravelerSlice.travelers[i] = travelerYouthDummy;
      } else if (traveler.passengerType === "STU") {
        nextTravelerSlice.travelers[i] = travelerStudentDummy;
      }
    });
    dispatch(setFullTravelerInformationSlice(nextTravelerSlice));
  };

  return (
    <>
      {showAutoFill && (
        <Button variant="text" onClick={autofillForms}>
          Autofill forms
        </Button>
      )}
    </>
  );
};
